import PropTypes from "prop-types"
import { selectAuth } from "./slice"
import { useSelector } from "react-redux"

/** A component that renders its children if the user is currently authenticated
 * with a non-expired set of claims in state, otherwise routes the user to the
 * login page. */
const AuthRequired = ({ children }) => {
  const claims = useSelector(selectAuth)
  const authed =
    claims?.sub && claims?.exp && claims?.exp * 1000 > new Date().getTime()

  // If auth is busy loading, or user is on login page, render children (edge case)
  if (
    claims?._loadStatus == "loading" ||
    window.location.href.indexOf("/login") != -1
  ) {
    return children
  }

  if (!authed) {
    // Send to login page instead
    // If not already on login route
    if (window.location.href.indexOf("/login") == -1) {
      // Grab current location (react-router/history stack, not full URL)
      // and store in localStorage
      let currentLoc = `${window.location.pathname}${window.location.search}`
      // TODO this is a temp hack to get things working in prod (handle properly)
      let newCurrentLoc = currentLoc.replace("/synapse", "")
      localStorage.setItem("previousDestination", newCurrentLoc)
      // Hack to cater for the fact that in prod we might be prefixed
      // with /synapse - but in local dev we aren't.
      // Note: We don't use history.push but instead reload
      // the page, to also force client to refresh / update app.
      if (window.location.pathname.startsWith("/synapse")) {
        window.location.href = "/synapse/login"
      } else {
        window.location.href = "/login"
      }
    }
    // So that child content does not briefly display
    // before location redirect.
    return null
  }

  // Render children
  return children
}

AuthRequired.propTypes = {
  children: PropTypes.any,
}

export default AuthRequired
